var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.photos),function(photo){return _c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{class:("photo " + (photo.ID)),style:(("background-image: url(" + (photo.imgUrl) + ");"))},[_c('span',{staticClass:"icon-deconnexion",on:{"click":function($event){_vm.askToKillPhoto(photo.ID)}}})])])}))}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afb9b0f8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/js/components/social-wall/SocialWallDashboardList.vue
// module id = C+Yr
// module chunks = 0